package com.essntl.features.supplier.ui

import androidx.compose.foundation.layout.*
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import com.essntl.features.contact.ui.ContactEvent
import com.essntl.features.contact.ui.ContactState
import com.essntl.features.contact.ui.components.ContactDropdownType
import com.essntl.features.contact.ui.components.ContactsDropDown
import com.essntl.features.organization.domain.model.OrganizationModel
import com.essntl.features.supplier.domain.model.SupplierModel
import com.essntl.uikit.components.button.primary.EsLargePrimaryButton
import com.essntl.uikit.components.dialog.EsDialog
import com.essntl.uikit.components.utils.spacing

@Composable
fun ChangeSupplierPopup(
    state: ContactState,
    onEvent: (ContactEvent) -> Unit,
    isOpen: Boolean,
    onDismissRequest: () -> Unit,
    onSelectSupplier: (SupplierModel) -> Unit,
    title: String = "Change supplier",
    buttonText: String = "Change",
    favoriteSuppliers: List<SupplierModel> = emptyList(),
    modifier: Modifier = Modifier,
) {
    var supplier by remember { mutableStateOf<SupplierModel>(SupplierModel.empty) }

    LaunchedEffect(isOpen) {
        if (isOpen) supplier = SupplierModel.empty
    }

    if (isOpen)
        EsDialog(
            title = title,
            onDismissRequest = onDismissRequest,
            modifier = modifier,
        ) {
            Column(
                verticalArrangement = Arrangement.Center,
                horizontalAlignment = Alignment.CenterHorizontally,
                modifier = Modifier
                    .padding(2.5.spacing),
            ) {
                Spacer(modifier = Modifier.height(3.spacing))

                ContactsDropDown(
                    state = state,
                    onEvent = onEvent,
                    type = ContactDropdownType.SUPPLIER,
                    selectedContact = supplier.id,
                    label = "Supplier",
                    placeholder = "Select supplier",
                    starredItem = { c ->
                        favoriteSuppliers
                            .map { it.id }
                            .contains(c)
                    },
                    onItemSelected = { id ->
                        supplier = SupplierModel.empty.copy(id = id)
                    },
                )

                Spacer(modifier = Modifier.height(4.5.spacing))

                EsLargePrimaryButton(
                    text = buttonText,
                    onClick = {
                        onDismissRequest()
                        onSelectSupplier(supplier)
                    },
                    enabled = state.getAllContacts.data.orEmpty().isNotEmpty() &&
                        !state.getAllContacts.isLoading &&
                        !state.getAllContacts.isFailure &&
                        supplier != SupplierModel.empty,
                    modifier = Modifier.fillMaxWidth(),
                )
            }
        }
}